import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ConfirmationService } from '@app/shared/services/confirmation/confirmation.service';
import { filter } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'sbnb-connect-flow-template',
  templateUrl: './connect-flow-template.component.html',
  styleUrls: ['./connect-flow-template.component.scss'],
})
export class ConnectFlowTemplateComponent implements OnInit {
  showLogo = true;

  private confirmationData: {
    message: string;
    handler: () => boolean;
  } | null = null;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private confirmationService: ConfirmationService
  ) {
    this.confirmationService.getConfirmation().subscribe((data) => {
      this.confirmationData = data;
    });
  }

  ngOnInit() {
    // First, handle the initial route
    this.handleRoute(this.activatedRoute);

    // Then, listen for future route changes
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.handleRoute(this.activatedRoute);
    });
  }

  private handleRoute(activatedRoute: ActivatedRoute) {
    // Find the active route
    let active = activatedRoute;
    while (active.firstChild) {
      active = active.firstChild;
    }

    this.showLogo = !!(active.snapshot.routeConfig && active.snapshot.routeConfig.path !== 'new/booking');
  }

  close() {
    if (this.confirmationData && !this.confirmationData.handler()) {
      return; // User cancelled, do nothing
    }

    this.router.navigate(['/accounts']);
  }
}
